<!-- required to build an id for checkbox because of label -->
<input #input
       type="checkbox"
       [attr.id]="checkboxId"
       [formControl]="control"/>
<label [for]="checkboxId" >{{  label }}<span></span></label>

